<template>
  <div id="app" v-on:scroll="changeTransition" @wheel="changeTransition">
    <transition name="slideup" >
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        transition: 'slideup'
      }
    },
    methods: {
      changeTransition: function (event) {
        if (event.type === 'wheel') {
          if (event.deltaY < 0) {
            this.transition = 'slideup'
            return
          }
        }
        if (event.type === 'wheel' || (window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
          if (event.deltaY > 0) {
            this.transition = 'slidedown'
          }
        }
      }
    }
  }

</script>

<style lang="scss" rel="stylesheet/scss">
  @import './assets/styles/colors.scss';

  html, body, #app {
    background-color: #EFF7FB;
    width: 100%;
    /*min-width: 450px;*/
    min-height: 500px;
    height: auto !important;
    position: fixed;
    top: 0;
    left: 0;
    font-family: "Open Sans", sans-serif;
    font-weight: normal;
    font-size: 14px;

  }

  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,700,800');

  #app {
    @media (max-width: 576px) {
      overflow-y: scroll;
    }
  }

  i {
    font-family: "Open Sans", sans-serif;
    font-style: normal;
    font-weight: normal;
    speak: none;
  }

  .aqua {
    color: $dark-blue-3;
  }

  ::-webkit-scrollbar {
    width: 0px;
  }

  .slideup-enter-active,
  .slideup-leave-active,
  .slidedown-enter-active,
  .slidedown-leave-active {
    transition: all 0.4s;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .slideup-enter {
    transform: translateY(100%);
  }

  .slideup-enter-to,
  .slideup-leave {
    transform: translateY(0);
  }

  .slideup-leave-to {
    transform: translateY(-100%);
  }

  .slidedown-enter {
    transform: translateY(-100%);
  }

  .slidedown-enter-to,
  .slidedown-leave {
    transform: translateY(0);
  }

  .slidedown-leave-to {
    transform: translateY(100%);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .slide-up-down-enter-active, .slide-up-down-leave-active {
    transition: transform .3s ease-in-out;
  }

  .slide-up-down-enter-to, .slide-up-down-leave {
    transform: translateY(0);
  }

  .slide-up-down-leave-to, .slide-up-down-enter {
    transform: translateY(-100%);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue